module.exports = __webpack_public_path__ + "img/hover_icon_proceso_de_carga.ea881d89.svg";